import { AfterViewInit, ChangeDetectionStrategy, Component, inject, Input, signal } from '@angular/core';
import { FeatureService } from '../shared/services/feature.service';
import { Observable } from 'rxjs';
import { CallbackOnCallNote } from '../shared/models/constant.model';
import { I18nKeys } from '../shared/models/i18n.model';
import { IconEnum } from '../shared/models/assets.model';

@Component({
	selector: 'app-note',
	standalone: false,
	templateUrl: './note.html',
	styleUrl: './note.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Note implements AfterViewInit {
	@Input() printMode = false;
	@Input() forceExpanded = false;

	private featureService: FeatureService = inject(FeatureService);

	public isExpanded = signal(false);
	public callNoteResponse$: Observable<CallbackOnCallNote> =
		this.featureService.callbackOnCallNoteData$;

	ngAfterViewInit(): void {
		if (this.printMode || this.forceExpanded) {
			this.isExpanded.set(true);
		}
		if (this.printMode) {
			setTimeout(() => window.print(), 500);
		}
	}

	toggleView() {
		this.isExpanded.update((v) => !v);
	}

	triggerPrint() {
		window.print();
	}

	protected readonly I18N = I18nKeys;
	protected readonly ICONS = IconEnum;
}
